'use client';

import { useEffect, useState } from 'react';
import NextImage from 'next/image';

interface BreakPoints {
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    '2xl'?: number;
    '3xl'?: number;
}

interface ImageAdaptiveProps {
    src?: string;
    baseWidth: number;
    breakpoints?: BreakPoints;
    className?: string;
    onClick?: () => void;
}

export default function ImageAdaptive({
    src,
    baseWidth,
    breakpoints = {},
    className = '',
    onClick,
}: ImageAdaptiveProps) {
    const [currentWidth, setCurrentWidth] = useState<number>(baseWidth);

    useEffect(() => {
        const updateWidth = () => {
            const width = window.innerWidth;
            if (width >= 1920 && breakpoints['3xl']) {
                setCurrentWidth(breakpoints['3xl']);
            } else if (width >= 1536 && breakpoints['2xl']) {
                setCurrentWidth(breakpoints['2xl']);
            } else if (width >= 1280 && breakpoints.xl) {
                setCurrentWidth(breakpoints.xl);
            } else if (width >= 1024 && breakpoints.lg) {
                setCurrentWidth(breakpoints.lg);
            } else if (width >= 768 && breakpoints.md) {
                setCurrentWidth(breakpoints.md);
            } else if (width >= 640 && breakpoints.sm) {
                setCurrentWidth(breakpoints.sm);
            } else {
                setCurrentWidth(baseWidth);
            }
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, [baseWidth, breakpoints]);

    if (!src || currentWidth === null) return null;

    const isSvg = src.endsWith('.svg');
    if (isSvg) {
        return (
            <img
                src={src}
                alt=""
                width={currentWidth}
                onClick={onClick}
                className={`max-w-none flex-shrink-0 ${className}`}
                style={{ height: 'auto' }}
            />
        );
    }

    return (
        <NextImage
            src={src}
            alt=""
            width={currentWidth}
            height={0}
            onClick={onClick}
            quality={85}
            className={`max-w-none flex-shrink-0 ${className}`}
            style={{ height: 'auto' }}
        />
    );
}
